import {
  CHILD_NODES_URL,
  DELETE_NODE_URL,
  PROPERTIES_URL,
  RESOURCES_URL,
  RESOURCE_PROPERTIES_URL,
  ROOT_NODES_URL
} from '../constants/ApiUri';
import { Property, Resource } from '../types/DataExplorer';

import { Http } from 'vrlcm-gui-utils';

export const getRootNodes = async (): Promise<Resource[]> => {
  const response = await Http.get<Resource[]>(ROOT_NODES_URL);
  return response.data;
};

export const getChildNodes = async (vmid: string): Promise<Resource[]> => {
  const response = await Http.get<Resource[]>(CHILD_NODES_URL(vmid));
  return response.data;
};

export const addNode = async (node: Resource): Promise<Resource> => {
  const response = await Http.post<Resource>(RESOURCES_URL, node);
  return response.data;
};

export const editNode = async (node: Resource): Promise<Resource> => {
  const response = await Http.put<Resource>(RESOURCES_URL, node);
  return response.data;
};

export const deleteNode = async (vmid: string): Promise<void> => {
  const response = await Http.delete(DELETE_NODE_URL(vmid));
  return response.data;
};

export const getResourceProperties = async (
  vmid: string
): Promise<Property[]> => {
  const response = await Http.get<Property[]>(RESOURCE_PROPERTIES_URL(vmid));
  return response.data;
};

export const addProperty = async (property: Property): Promise<Property> => {
  const response = await Http.post<Property>(PROPERTIES_URL, property);
  return response.data;
};
